import styled from "styled-components";

export const AboutContainer = styled.section`
  background-color: lightcoral;
  padding: 50px;

  @media (max-width: 1400px) {
  padding: 20px;
  }
`;

export const AboutTextWrapper = styled.div`
  width: 90vw;
  letter-spacing: -0.5;
  font-family: 'Spectral', 'times', serif;
  font-size: 1.3rem;
  line-height: 1.3;

  @media (max-width: 1400px) {
    font-size: 0.8rem;
  }
`;

export const AboutTitle = styled.h4`
  margin: 0;
  text-transform: uppercase;
  font-weight: light;
`;

export const AboutText = styled.p`
`;

export const Credits = styled.span`
`;

export const CreditLink = styled.a`
  cursor: pointer;
  text-decoration: none;
  font-style: italic;
  color: black;
`;